<template>
  <div class="container" id="vocabularyWrapper">
    <a id="mobileSearchIcon" v-on:click.stop.prevent="onSearchFocus()" href="#"><img src="/img/icons/vocSearch.png" alt="Search"></a>

    <div v-on:click="onSearchBlur()" id="vocBackdrop" :class="[$store.state.searchFocus ? 'shown' : '']"></div>

    <div id="h1" v-on:click="openPhrase('1', 'Damík', '/', true)">
      {{ $t('it-slovnik') }}
    </div>

    <div id="whatVocabularyIs">
      {{ $t('vyznam-slovniku') }}
    </div>

    <div id="searchWrapper" :class="[$store.state.searchFocus ? 'focus' : '']">
      <svg id="searchIcon" width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M19.0918 15.5563C16.7486 17.8995 12.9496 17.8995 10.6065 15.5563C8.26333 13.2132 8.26333 9.41421 10.6065 7.07107C12.9496 4.72792 16.7486 4.72792 19.0918 7.07107C21.4349 9.41421 21.4349 13.2132 19.0918 15.5563ZM9.94314 17.6339C13.0816 20.0764 17.6213 19.8553 20.506 16.9706C23.6302 13.8464 23.6302 8.78105 20.506 5.65685C17.3818 2.53266 12.3165 2.53266 9.19227 5.65685C6.30754 8.54158 6.08643 13.0813 8.52893 16.2197L4.94963 19.799L6.36384 21.2132L9.94314 17.6339Z"
              fill="#061F35"/>
      </svg>
      <svg id="closeIcon" v-on:click="onSearchBlur()" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M15.3404 1.60115L1.47078 15.4708L0 14L13.8696 0.130364L15.3404 1.60115Z" fill="#061F35"/>
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M1.47181 -5.50981e-06L15.3911 13.9193L13.9194 15.391L0.000123539 1.47168L1.47181 -5.50981e-06Z"
              fill="#061F35"/>
      </svg>

      <input ref="searchInput" autocomplete="off" v-on:keydown="handleKeyDown" v-model="searchQuery" v-debounce:300ms="onSearch" v-on:focus="onSearchFocus()" type="text" id="search" :placeholder="$t('vyhledejte-vyraz')">
      <div id="searchResults">
        <perfect-scrollbar class="content">

          <div :class="['line', index === searchSelectedItemIndex ? 'selected' : '']" v-for="(item, index) in searchResults" :key="item.phraseID" v-on:click.stop.prevent="openPhraseLocal(item)">
            <div class="phrase">
              {{item.phrase}}
            </div>
            <div class="description">
              {{item.meaning}}
            </div>
          </div>

        </perfect-scrollbar>
        <div class="status">
          <span v-if="searchQuery.length < 2">
            {{ $t('zadejte-alespon-dva-znaky') }}
          </span>
          <span v-else-if="searchState === this.$store.const.SEARCH_STATE_SEARCHING">
            {{ $t('vyhledavani') }}
          </span>
          <span v-else-if="searchState === this.$store.const.SEARCH_STATE_NO_RESULTS" class="error">
            {{ $t('zadne-vysledky') }}
          </span>
          <span v-else-if="searchState === this.$store.const.SEARCH_STATE_ERROR" class="error">
            {{ $t('chyba-vyhledavani') }}
          </span>
        </div>
      </div>
    </div>

    <div id="keyboard" :class="[lettersFiltered.length === 0 ? 'preloader' : '']">
      <div class="letter" v-on:click="selectLetter" v-for="item in lettersFiltered" :key="item">{{item}}</div>
      <template v-if="lettersFiltered.length === 0">

        <div class="letter"></div>
        <div class="letter"></div>
        <div class="letter"></div>
        <div class="letter"></div>
        <div class="letter"></div>
        <div class="letter"></div>
        <div class="letter"></div>
        <div class="letter"></div>
        <div class="letter"></div>
        <div class="letter"></div>

      </template>
    </div>

    <div :class="['row', $store.state.mobileDetailShown ? 'detailOpened' : '']" id="mainRow">
      <div class="col-lg-3 col-md-4" id="colVocNav">

        <div id="vocNav">
            <perfect-scrollbar :options="{suppressScrollX: true}" ref="scroll" class="inner">

              <Letter @resetScroll="resetScroll" @openPhrase="openPhrase" v-for="item in navFiltered" :key="item.key" :char="item.key" :phrases="item.phrases"></Letter>
              <div v-if="navFiltered.length === 0" class="preloader">

                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>

              </div>

            </perfect-scrollbar>

        </div>

      </div>
      <div class="col-lg-9 col-md-8" id="colBox">

        <div class="box noHover" :id="'phraseContent' + $store.state.selectedPhraseID" v-on:click="mobileShowDetail">
          <svg v-if="$store.state.selectedPhraseID === 1" id="damikBox" width="94" height="66" viewBox="0 0 94 66" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0)">
                      <rect x="-1274" y="-538" width="1900" height="2066" fill="white"/>
                      <g filter="url(#filter0_d)">
                        <rect x="-553" width="768" height="689" fill="white"/>
                      </g>
                      <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="-55" width="94" height="121">
                        <g clip-path="url(#clip1)">
                          <path d="M46.899 10.901C58.0173 10.901 64.4861 19.5935 64.4861 19.5935C67.8553 19.5935 80.4897 4.76913 85.5771 -6.82084C90.6646 -18.4108 95.0782 -27.9456 92.9893 -30.0008C91.6416 -31.3484 84.4316 -31.3147 83.2861 -30.8431C82.1406 -30.3714 81.7026 -29.2932 80.1528 -25.4861C78.8725 -22.319 77.4911 -19.4216 76.2445 -16.9958C75.975 -16.423 73.0438 -16.8273 73.2459 -17.4C74.3915 -20.3649 75.6381 -23.8352 76.6488 -27.575C77.9291 -32.157 79.0409 -34.5829 79.7485 -38.1542C80.456 -41.7255 82.1743 -50.7212 80.2538 -52.17C77.6596 -54.1241 74.4252 -54.0567 65.5979 -54.5284C56.8044 -55.0001 54.7155 -53.3829 54.7155 -53.3829L54.7155 -48.4639C54.7155 -46.914 52.1549 -44.5893 46.8316 -44.5893C41.5083 -44.5893 38.9477 -46.914 38.9477 -48.4639L38.9477 -53.3829C38.9477 -53.3829 36.8589 -55.0001 28.0653 -54.5284C19.2718 -54.0567 17.3513 -54.1241 14.7908 -52.17C12.8703 -50.7212 13.4094 -41.9277 14.1169 -38.3563C14.8244 -34.785 15.7341 -32.1571 17.0144 -27.5413C18.0588 -23.8015 19.2718 -20.2975 20.4173 -17.3664C20.6531 -16.7936 17.7219 -16.3893 17.4187 -16.9621C16.1721 -19.4216 14.8244 -22.2854 13.5105 -25.4524C11.9606 -29.2596 11.5563 -30.3377 10.3771 -30.8094C9.19792 -31.2811 1.98789 -31.3148 0.673909 -29.9671C-1.41498 -27.8782 2.99864 -18.3434 8.08609 -6.78715C13.1735 4.76912 25.808 19.6272 29.1771 19.6272C29.2782 19.5935 35.7807 10.901 46.899 10.901Z" fill="#80CE1B"/>
                          <path d="M40.0932 20.6272C31.5692 20.6272 17.5534 20.6272 11.9269 20.6272C4.85164 20.6272 1.58354 29.2859 0.774928 35.5189C-0.0673654 41.7519 1.41508 45.6264 7.64806 48.4902C9.46741 49.3325 11.4215 50.0064 13.4767 50.6128L1.7183 61.091C0.572785 62.1017 0.471703 63.8874 1.48246 65.0329C2.49321 66.1784 4.27888 66.2795 5.4244 65.2687L20.0803 52.1963C23.2136 52.8028 26.3807 53.2408 29.4803 53.5777C37.0273 54.42 47.0674 54.42 47.0674 54.42C47.0674 54.42 57.1075 54.42 64.6545 53.5777C67.8552 53.2071 71.1233 52.7691 74.324 52.129L89.0136 65.2687C90.1592 66.2795 91.9448 66.1784 92.9556 65.0329C93.9663 63.8874 93.8652 62.1017 92.7197 61.091L80.9276 50.5118C82.9154 49.9053 84.8022 49.2315 86.5204 48.4566C92.7534 45.6265 94.2359 41.7519 93.3936 35.5189C92.5513 29.2859 89.3169 20.6272 82.2416 20.6272C76.5477 20.6272 62.2961 20.6272 53.7721 20.6272L40.0932 20.6272ZM60.0387 32.6214C60.1398 32.6214 60.2746 32.6551 60.342 32.7225L64.2165 36.1591C64.385 36.3275 64.6545 36.3275 64.823 36.1591L68.6975 32.7562C68.7649 32.6888 68.8997 32.6551 69.0007 32.6551C71.8645 32.6551 73.2459 36.0917 71.1233 37.9447L66.6423 41.9204C65.4294 42.9648 63.6101 42.9648 62.4308 41.9204L57.9498 37.9447C55.7936 36.058 57.1749 32.6214 60.0387 32.6214ZM25.4373 32.6214C25.5384 32.6214 25.6731 32.6551 25.7405 32.7225L29.6151 36.1591C29.7835 36.3275 30.0531 36.3275 30.2215 36.1591L34.0961 32.7225C34.1635 32.6551 34.2982 32.6214 34.3993 32.6214C37.2631 32.6214 38.6445 36.058 36.5219 37.911L32.0072 41.8867C30.7943 42.9311 28.9749 42.9311 27.7957 41.8867L23.3147 37.911C21.1921 36.058 22.5735 32.6214 25.4373 32.6214Z" fill="#80CE1B"/>
                        </g>
                      </mask>
                      <g mask="url(#mask0)">
                        <rect x="105" y="72" width="120" height="72" transform="rotate(-180 105 72)" fill="#80CE1B"/>
                      </g>
                    </g>
                    <defs>
                      <filter id="filter0_d" x="-593" y="-20" width="848" height="769" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
                        <feOffset dy="20"/>
                        <feGaussianBlur stdDeviation="20"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
                      </filter>
                      <clipPath id="clip0">
                        <rect x="-1274" y="-538" width="1900" height="2066" fill="white"/>
                      </clipPath>
                      <clipPath id="clip1">
                        <rect x="94" y="66" width="94" height="121" transform="rotate(-180 94 66)" fill="white"/>
                      </clipPath>
                    </defs>
                  </svg>

          <div class="content" itemscope itemprop="mainEntity" itemtype="https://schema.org/Question">

            <Preloader :preloaderTitle="preloaderTitle" v-if="$store.state.preloaderShown"></Preloader>
            <div v-else>
              <h1>{{phrase.phrase}}</h1>
              <div class="meaning" v-if="phrase.meaning !== null">{{phrase.meaning}}</div>

              <div class="block what" v-if="phrase.what.length > 0">
                <h2 itemprop="name">{{ $t('co-je-to') }} {{phrase.phrase}}?</h2>
                <div itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer">
                  <div v-html="phrase.what" itemprop="text"></div>
                </div>
              </div>

              <div class="block" v-if="phrase.where.length > 0">
                <h2> {{ $t('kde-se-s-tim-setkate') }} </h2>
                <div v-html="phrase.where"></div>
              </div>

              <div class="block similar" v-if="phrase.similar.length > 0">
                <h2>{{ $t('podobne-vyrazy') }}</h2>
                <ul>
                  <li v-for="item in phrase.similar"><span v-html="item"></span></li>
                </ul>
              </div>

              <div class="block relatedWrapper" v-if="phrase.related.length > 0">
                <h2> {{ $t('mohlo-by-vas-zajimat') }} </h2>
                <div class="related">
                  <a v-for="item in phrase.related" :href="item.url" v-on:click.stop.prevent="openPhrase(item.phraseID, item.phrase, item.url, true)">{{item.phrase}}</a>
                </div>
              </div>
              <div v-if="phrase.cta" class="call-to-action mt-3 closestAutoClick cursorPointer" @click="redirectToCtaLink">
                <div class="d-flex align-items-center" style="gap: 25px">
                  <div class="vocabulary-call-to-action-image-overlay">
                    <img width="128px" :src="phrase.ctaImage" :alt="phrase.translatedCta">
                  </div>
                  <div class="flex-column p-2">
                    <div class="title">
                      <h3>{{phrase.translatedCta}}</h3>
                    </div>
                    <div class="d-flex align-items-center">
                      <a :href="phrase.ctaLink">{{callToAction}}</a> <img class="mx-2" width="15px" height="15px" src="/img/icons/icon-arrow-right.svg">
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>

        </div>

      </div>
    </div>

  </div>
</template>

<script>
    import Letter from './components/Letter';
    import Preloader from './components/Preloader';
    import axios from 'axios';
    import 'es6-promise/auto'

    export default {
        name: 'app',

        components: {
            Letter,
            Preloader
        },
        data() {
            return {
                letters: ['0-9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
                preloaderTitle: "",
                searchQuery: "",
                searchSelectedItemIndex: 0,
                searchState: this.$store.const.SEARCH_STATE_READY,
                searchResults: [],
                nav: [
                    {
                        "key": "0-9",
                        "phrases": []
                    },
                    {
                        "key": "A",
                        "phrases": []
                    },
                    {
                        "key": "B",
                        "phrases": []
                    },
                    {
                        "key": "C",
                        "phrases": []
                    },
                    {
                        "key": "D",
                        "phrases": []
                    },
                    {
                        "key": "E",
                        "phrases": []
                    },
                    {
                        "key": "F",
                        "phrases": []
                    },
                    {
                        "key": "G",
                        "phrases": []
                    },
                    {
                        "key": "H",
                        "phrases": []
                    },
                    {
                        "key": "I",
                        "phrases": []
                    },
                    {
                        "key": "J",
                        "phrases": []
                    },
                    {
                        "key": "K",
                        "phrases": []
                    },
                    {
                        "key": "L",
                        "phrases": []
                    },
                    {
                        "key": "M",
                        "phrases": []
                    },
                    {
                        "key": "N",
                        "phrases": []
                    },
                    {
                        "key": "O",
                        "phrases": []
                    },
                    {
                        "key": "P",
                        "phrases": []
                    },
                    {
                        "key": "Q",
                        "phrases": []
                    },
                    {
                        "key": "R",
                        "phrases": []
                    },
                    {
                        "key": "S",
                        "phrases": []
                    },
                    {
                        "key": "T",
                        "phrases": []
                    },
                    {
                        "key": "U",
                        "phrases": []
                    },
                    {
                        "key": "V",
                        "phrases": []
                    },
                    {
                        "key": "W",
                        "phrases": []
                    },
                    {
                        "key": "X",
                        "phrases": []
                    },
                    {
                        "key": "Y",
                        "phrases": []
                    },
                    {
                        "key": "Z",
                        "phrases": []
                    }
                ],
                phrase: window.phrase,
                callToAction: window.callToAction,
                language: window.language,
            }
        },
        created: function() {
            var that = this;
            axios
                .get(process.env.BASE_URL + '/phrase/index', {
                  params: {
                    lang: window.language
                  }
                })
                .then(function(response){
                    that.nav = response.data
                    if(that.$store.state.selectedPhraseID !== 1)
                    {
                        that.leftMenuSelectCurrentPhrase()
                    }
                })
                .catch(function (error) {

                })

            window.addEventListener('resize', this.handleResize);
            this.handleResize();

            if(that.$store.state.selectedPhraseID !== null)
            {
              that.updateMetaTags();
            }

        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize);
        },
        computed: {
            randomFaqEmoji: function() {
              let emojis = ['📗', '📖', '📚', '🔎', '💡', '❓', '🤔', '👉'];
              return emojis[Math.floor(Math.random()*emojis.length)];
            },
            lettersFiltered: function () {
                //return [];
                var that = this;
                return this.letters.filter(function(item) {
                    return that.nav.find(x => x.key === item).phrases.length > 0
                });
            },
            navFiltered: function () {
                //return [];
                return this.nav.filter(function(item) {
                    return item.phrases.length > 0
                });
            },
            searchSelectedPhrase: function () {
                if(this.searchResults.length > 0 && this.searchResults.length >= this.searchSelectedItemIndex + 1)
                {
                    return this.searchResults[this.searchSelectedItemIndex];
                }
                return null;
            }
        },
        methods: {
            redirectToCtaLink() {
              if (this.phrase.ctaLink) {
                window.location.href = this.phrase.ctaLink;
              }
            },
            mobileShowDetail() {
                this.$store.log("click");
                this.$store.state.mobileDetailShown = true;
            },
            resetScroll() {
                this.$store.log("reseting scroll")
                this.$refs.scroll.update()
            },
            handleResize() {
                this.$store.setWindowWidth(window.innerWidth);
            },
            handleKeyDown(e) {
                if(this.$store.state.searchFocus && this.searchResults.length)
                {
                  if(e.key === "ArrowDown" && this.searchResults.length > this.searchSelectedItemIndex + 1)
                  {
                      this.searchSelectedItemIndex++;
                      e.preventDefault();
                  }
                  else if(e.key === "ArrowUp" && this.searchSelectedItemIndex > -1)
                  {
                      this.searchSelectedItemIndex--;
                      e.preventDefault();
                  }
                  else if(e.key === "Enter" && this.searchSelectedItemIndex >= 0)
                  {
                      if(this.searchSelectedPhrase !== null)
                      {
                          let el = this.$el.querySelector(':focus');
                          if(el) el.blur();

                          this.openPhraseLocal(this.searchSelectedPhrase);
                      }
                      e.preventDefault();
                  }
                }
            },
            onSearchFocus: function () {
                this.$store.setSearchFocus(true)
                var that = this;

                this.$nextTick(() => {
                  that.$refs.searchInput.focus();
                });
            },
            onSearchBlur: function () {
                this.$store.setSearchFocus(false)
            },
            onSearch: function () {

                var that = this;
                that.searchSelectedItemIndex = -1;
                that.searchState = this.$store.const.SEARCH_STATE_SEARCHING;

                axios
                    .get(process.env.BASE_URL + '/phrase/search?query=' + this.searchQuery, {
                      params: {
                        lang: window.language
                      }
                    })
                    .then(function (response) {
                        that.searchResults = response.data
                        if(that.searchResults.length > 0)
                        {
                            that.searchSelectedItemIndex = 0;
                            that.searchState = that.$store.const.SEARCH_STATE_READY;
                        }
                        else{
                            that.searchState = that.$store.const.SEARCH_STATE_NO_RESULTS;
                        }
                    }).catch(function (error) {
                        that.searchState = that.$store.const.SEARCH_STATE_ERROR;
                    })

            },
            selectLetter: function (event) {
                var VueScrollTo = require('vue-scrollto');
                var options = {
                    container: '#vocNav .inner',
                    easing: 'ease',
                    offset: 0,
                    x: false,
                    y: true
                };

                if(this.$store.state.selectedLetter !== null)
                {
                    this.$store.setSelectedLetter(event.target.innerText)
                    window.setTimeout(() => VueScrollTo.scrollTo('#navSegment' + event.target.innerText, 500, options), 500);
                }
                else{
                    this.$store.setSelectedLetter(event.target.innerText)
                    VueScrollTo.scrollTo('#navSegment' + event.target.innerText, 500, options)
                }
            },
            openPhraseLocal: function (phrase) {
                this.$store.log("openPhraseLocal")
                this.$store.setMobileDetailShown(true);
                this.searchQuery = "";

                var VueScrollTo = require('vue-scrollto');
                var options = {
                    easing: 'ease',
                    force: true,
                    offset: this.$store.state.windowWidth >= 992 ? 100 : 20,
                };
                window.setTimeout(() => {VueScrollTo.scrollTo('h1', 500, options)}, 100)

                window.document.title = this.$t('co-je-to') + phrase.phrase + " | DAMI";
                history.pushState({}, phrase.phrase, phrase.url);

                this.$store.setSelectedPhraseID(phrase.phraseID);
                this.phrase = phrase;
                this.onSearchBlur();

                this.leftMenuSelectCurrentPhrase();
            },
            openPhrase: function (_phraseID, _phrase, _url, menuAutoScroll) {
                var VueScrollTo = require('vue-scrollto');

                let offset = 100;

                if(this.$store.state.windowWidth < 1600 && this.$store.state.windowWidth >= 992)
                {
                    offset = 40;
                }
                else if(this.$store.state.windowWidth < 992){
                    offset = 20;
                }

                var options = {
                    easing: 'ease',
                    offset: offset,
                };
                VueScrollTo.scrollTo('h1', 500, options)

                this.preloaderTitle = _phrase;
                this.searchQuery = "";
                this.$store.setMobileDetailShown(true);

                window.document.title = this.$t('co-je-to') + _phrase + " | DAMI";
                history.pushState({}, _phrase, _url);

                this.$store.setSelectedPhraseID(_phraseID);

                var that = this;
                var isRequestDone = false;
                var forceHidePreloaderOnRequestDone = false;
                var preloader;

                //run preloader immediately on mobiles
                if(this.$store.state.windowWidth < 992)
                {
                    this.$store.setPreloaderShown(true);
                    preloader = window.setTimeout(() => {
                        if(isRequestDone)
                        {
                            that.$store.setPreloaderShown(false);
                        }
                        else{
                            forceHidePreloaderOnRequestDone = true;
                            that.$store.log("setting forceHidePreloaderOnRequestDone = true");
                        }
                    }, 500);
                }
                else{
                    //delayed run preloader because of fast server response
                    preloader = window.setTimeout(() => {
                        that.$store.setPreloaderShown(true);
                    }, 150);
                }

                axios
                    .get(process.env.BASE_URL + '/phrase/' + _phraseID, {
                      params: {
                        lang: window.language
                      }
                    })
                    .then(function (response) {
                        that.phrase = response.data;

                        //not hide preloader on mobile phone
                        if(that.$store.state.windowWidth >= 992 || forceHidePreloaderOnRequestDone)
                        {
                            window.clearInterval(preloader);
                            that.$store.setPreloaderShown(false);
                        }

                        if(menuAutoScroll)
                        {
                            that.leftMenuSelectCurrentPhrase();
                        }
                        isRequestDone = true;
                    })
                    .catch(function (error) {
                        isRequestDone = true;
                    })
                  .finally(function () {
                    that.updateMetaTags();
                  })
            },
            leftMenuSelectCurrentPhrase: function () {
                this.$store.setSelectedLetter(this.phrase.phrase[0].toUpperCase());
                this.$store.setSelectedPhraseID(this.phrase.phraseID);

                var VueScrollTo = require('vue-scrollto');
                var options = {
                    container: '#vocNav .inner',
                    easing: 'ease',
                    offset: -200,
                };
                window.setTimeout(() => VueScrollTo.scrollTo('#navPhrase' + this.phrase.phraseID, 500, options), 700);
            },
            updateMetaTags: function () {
              // add new  alternate address
              const canonicalLink = document.querySelector('link[rel="canonical"]');
              const alternateLinkCz = document.querySelector('link[rel="alternate"][hreflang="cs"]');
              const alternateLinkEn = document.querySelector('link[rel="alternate"][hreflang="en"]');
              const alternateLinkDefault = document.querySelector('link[rel="alternate"][hreflang="x-default"]');
              if (alternateLinkCz) {
                alternateLinkCz.href = this.phrase.urlCz;
              }

              if (alternateLinkEn) {
                alternateLinkEn.href = this.phrase.urlEn;
              }

              alternateLinkDefault.href = this.phrase.urlCz;
              canonicalLink.href = this.phrase.url;

              const title = document.querySelector('meta[property="og:title"]');
              const description = document.querySelector('meta[property="og:description"]');
              const url = document.querySelector('meta[property="og:url"]');
              const metaDescription = document.querySelector('meta[name="description"]');

              const decodeAndStripHtml = html => {
                const txt = document.createElement("textarea");
                txt.innerHTML = html; // Decode HTML entities
                const decodedHtml = txt.value; // Get the decoded text
                const doc = new DOMParser().parseFromString(decodedHtml, 'text/html');
                return doc.body.textContent || ""; // Strip HTML tags
              };

              title.setAttribute('content', this.phrase.phrase)
              description.setAttribute('content', decodeAndStripHtml(this.phrase.what))
              metaDescription.setAttribute('content', decodeAndStripHtml(this.phrase.what))
              url.setAttribute('content', this.phrase.url)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/App.vue